import { useState } from 'react'
import FreebetsListTab from './FreebetsListTab'
import BetsHistoryTab from './BetsHistoryTab'
import FreebetHistoryCard from './FreebetHistoryCard'
import PurchaseCard from './PurchaseCard'

// Column headers per tab.
const ACTIVE_HEADER = [
  { label: 'Expiry Date' },
  { label: 'Source' },
  { label: 'Freebet Id' },
  { label: 'Stake', currency: true },
  { label: 'Action' },
]
const HISTORY_HEADER = [
  { label: 'Date' },
  { label: 'Source' },
  { label: 'Id' },
  { label: 'Stake', currency: true },
  { label: 'Win', currency: true },
]
const PURCHASE_HEADER = [
  { label: 'Date' },
  { label: 'Type' },
  { label: 'Amount', currency: true },
  { label: 'Status' },
]

// Active = placeable freebet grants (fetchFreebets, status ACTIVE).
const ACTIVE_STATUSES = ['ACTIVE']
// History = settled freebet BETS (players.bets, subType FREEBET). Purchases =
// buy-bonus purchase transactions (players.bets, type PURCHASE).
const HISTORY_FILTERS = { type: ['BET'], subType: ['FREEBET'], source: ['ALL'], status: ['COMPLETED'] }
const PURCHASE_FILTERS = { type: ['PURCHASE'], subType: ['ALL'], source: ['ALL'], status: ['COMPLETED'] }

const TAB_CONTENT = {
  ACTIVE: {
    KEY: 'ACTIVE',
    TAB_NAME: 'Active',
    COMPONENT: (
      <FreebetsListTab
        statuses={ACTIVE_STATUSES}
        headerElements={ACTIVE_HEADER}
        emptyMessage="No Active Freebets"
      />
    ),
  },
  HISTORY: {
    KEY: 'HISTORY',
    TAB_NAME: 'History',
    COMPONENT: (
      <BetsHistoryTab
        filters={HISTORY_FILTERS}
        headerElements={HISTORY_HEADER}
        Card={FreebetHistoryCard}
        emptyMessage="No Freebet History"
      />
    ),
  },
  PURCHASES: {
    KEY: 'PURCHASES',
    TAB_NAME: 'Purchases',
    COMPONENT: (
      <BetsHistoryTab
        filters={PURCHASE_FILTERS}
        headerElements={PURCHASE_HEADER}
        Card={PurchaseCard}
        emptyMessage="No Purchases Found"
      />
    ),
  },
}

const TABS = Object.values(TAB_CONTENT)

const FreebetsMenu = () => {
  const [currentTab, setCurrentTab] = useState(TABS[0].KEY)
  const [slideDirection, setSlideDirection] = useState(1)

  const activeIndex = TABS.findIndex((tab) => tab.KEY === currentTab)
  const activeTab = TAB_CONTENT[currentTab]

  const handleTabChange = (nextKey) => {
    if (nextKey === currentTab) return
    const nextIndex = TABS.findIndex((tab) => tab.KEY === nextKey)
    setSlideDirection(nextIndex >= activeIndex ? 1 : -1)
    setCurrentTab(nextKey)
  }

  return (
    <div className="standard-normal-freebets-menu-outer-container">
      <div
        className="standard-normal-freebets-menu-tabs-container"
        style={{
          '--freebets-tab-count': TABS.length,
          '--freebets-tab-index': activeIndex,
        }}
      >
        {TABS.map((tab) => (
          <div
            key={tab.KEY}
            className={`standard-normal-freebets-menu-tab ${tab.KEY === currentTab ? 'standard-normal-freebets-menu-active-tab' : ''}`}
            onClick={() => handleTabChange(tab.KEY)}
          >
            {tab.TAB_NAME}
          </div>
        ))}
        <span className="standard-normal-freebets-menu-tab-indicator" aria-hidden="true" />
      </div>

      <div className="standard-normal-freebets-menu-content-container">
        <div
          key={currentTab}
          className="standard-normal-freebets-menu-content"
          style={{ '--freebets-slide-direction': slideDirection }}
        >
          {activeTab.COMPONENT}
        </div>
      </div>
    </div>
  )
}

export default FreebetsMenu
